import { Typography } from '@material-ui/core'
import { userInfo } from 'api/graphQL/reactiveVars/user'
import { WorkspaceActionBarContext } from 'pages/ProjectsPage/WorkspacePage/components/WorkspaceActionBarContext'
import React from 'react'
import { updatePersistentConfigs } from 'shared/utils/workspaceUtils'
import { useUnderMaintenanceStyles } from '../styles/useUnderMaintenanceStyles'
import {
    useIsUnderMaintenance,
    useLastError,
    useWorkspace2Actions,
} from '../Workspace2Store'
import { WorkspaceSwitchButton } from './WorkspaceSwitchButton'

/** Displays a maintenance overlay with an option to switch back to the previous editor. */
export const UnderMaintenance = React.memo(() => {
    const classes = useUnderMaintenanceStyles()
    const { setStateValue: setOldWorkspaceState } = React.useContext(
        WorkspaceActionBarContext
    )

    const { switchWorkspace } = useWorkspace2Actions()
    const isUnderMaintenance = useIsUnderMaintenance()
    const lastError = useLastError()

    // updates persistent configs and resets workspace state
    const handleSwitchWorkspace = React.useCallback(() => {
        updatePersistentConfigs(
            userInfo()?.currentUserInfo?.kpUserId,
            'Global',
            'betaWorkspaceToggleChecked',
            false
        )

        // reverts workspace to its previous state and disables beta features
        setOldWorkspaceState('showHideStates.betaWorkspace', false)
        switchWorkspace(false)
    }, [setOldWorkspaceState, switchWorkspace])

    if (!isUnderMaintenance) return null

    return (
        <div
            className={classes.overlayContainer}
            data-testid="under-maintenance-container"
        >
            <Typography
                data-testid="testUnderMaintenanceText"
                variant="h4"
                className={classes.maintenanceTitle}
            >
                Under Maintenance
            </Typography>

            {lastError && (
                <Typography variant="body1" className={classes.errorDetails}>
                    Something went wrong
                </Typography>
            )}

            <WorkspaceSwitchButton
                data-testid="testSwitchBetaWorkspaceBtn"
                onClick={handleSwitchWorkspace}
            />
        </div>
    )
})
